import type { NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap";

// ng-bootstrap öffnet Tooltips standardmäßig mit "hover focus". Ein Mausklick fokussiert das
// Host-Element, dadurch bleibt der Tooltip nach dem Verlassen mit der Maus offen, bis der Fokus
// wandert. Mit "hover" schließt er beim mouseleave; Tastaturfokus zeigt dafür keinen Tooltip mehr.
// NgbTooltipConfig ist providedIn root: einmal beim App-Start an der Root-Instanz gesetzt, gilt der
// Wert für jeden Tooltip, der kein eigenes `triggers` bindet.
export function applyTooltipDefaults(config: NgbTooltipConfig): void {
	config.triggers = "hover";
}
